export const loading = state => state.loading
export const membershipContext = state => state.membershipContext
export const myMemberships = state => state.myMemberships
export const businessId = state => state.membershipContext ? state.membershipContext.business : null
export const wizardIsActive = state => state.wizardIsActive
